const RUSSIA_PHONE_CODE = '+7';
const LOCAL_STORAGE_LAST_SEND_OTP_TIME = 'b8vspxwDKyiiq9R';
const DEFAULT_COOL_DOWN_TIME = 30 * 1000;
const DEFAULT_ERROR_MESSAGE = 'Неизвестная ошибка. Попробуйте позже.';
const DEFAULT_ERROR_MESSAGE_COUNT_DOWN_START_TIME = 5 * 1000;
const PHONE_LENGTH = 11;
const OTP_LENGTH = 4;
const FIRST_NAME_MIN_LENGTH = 2;
const FIRST_NAME_MAX_LENGTH = 255;
const TOO_MANY_REQUESTS_ERROR_TYPE = 'tooManyRequests';

export { DEFAULT_COOL_DOWN_TIME, DEFAULT_ERROR_MESSAGE, DEFAULT_ERROR_MESSAGE_COUNT_DOWN_START_TIME, FIRST_NAME_MAX_LENGTH, FIRST_NAME_MIN_LENGTH, LOCAL_STORAGE_LAST_SEND_OTP_TIME, OTP_LENGTH, PHONE_LENGTH, RUSSIA_PHONE_CODE, TOO_MANY_REQUESTS_ERROR_TYPE };
//# sourceMappingURL=index.js.map
